<template>
  <v-row no-gutters class="sideBySideToolbar secondary">
    <v-col cols="5">
      <v-row no-gutters>
        <v-col cols="12"
          lg="2"
          class="d-flex align-center mr-auto"
          order="2"
          order-lg="1">
          <span class="current-image-eye" :class="colorClass">{{sideBySideLeftEye}}</span>
        </v-col>
        <v-col 
          v-if="sideBySideLeftTimestamp"
          cols="12"
          lg="2"
          class="d-flex align-center mr-auto"
          order="2"
          order-lg="1">
          <span class="current-image-eye" :class="colorClass">{{sideBySideLeftTimestamp}}</span>
        </v-col>
        <v-col cols="12"
          lg="8"
          class="d-flex justify-center align-center"
          order="1"
          order-lg="2">
          <select-with-button
            :value="sideBySideLeftExSrNo"
            :items="exams"
            @change="changeExam(true, $event)"
            :icon-button="true"
            item-text="listText"
            item-value="exSrNo"
            class="toolbar-select oct-exam-select sideBySideToolbarSelect"/>
          <v-btn
            text
            icon
            class="modal-cta"
            :disabled="isDisabled(true, false)"
            @click="changeImage(true, false)">
            <v-icon>fas fa-caret-left</v-icon>
          </v-btn>
          <index-counter :index="sideBySideLeftIndex" :count="sideBySideLeftImages.length" />
          <v-btn
            text
            icon
            class="modal-cta"
            :disabled="isDisabled(true, true)"
            @click="changeImage(true, true)">
            <v-icon>fas fa-caret-right</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="2" class="d-flex justify-center align-center">
      <v-btn
        text
        icon
        class="modal-cta"
        :disabled="isDisabled(true, false) && isDisabled(false, false)"
        @click="changeImage(true, false); changeImage(false, false);">
        <v-icon>fas fa-caret-left</v-icon>
      </v-btn>
      <v-btn
        text
        icon
        class="modal-cta"
        :disabled="isDisabled(true, true) && isDisabled(false, true)"
        @click="changeImage(true, true); changeImage(false, true)">
        <v-icon>fas fa-caret-right</v-icon>
      </v-btn>
    </v-col>
    <v-col cols="5">
      <v-row no-gutters>
        <v-col cols="12"
          lg="8"
          class="d-flex justify-center align-center"
          order="1">
          <v-btn
            text
            icon
            class="modal-cta"
            :disabled="isDisabled(false, false)"
            @click="changeImage(false, false)">
            <v-icon>fas fa-caret-left</v-icon>
          </v-btn>
          <index-counter :index="sideBySideRightIndex" :count="sideBySideRightImages.length" />
          <v-btn
            text
            icon
            class="modal-cta"
            :disabled="isDisabled(false, true)"
            @click="changeImage(false, true)">
            <v-icon>fas fa-caret-right</v-icon>
          </v-btn>
          <select-with-button
            :value="sideBySideRightExSrNo"
            :items="exams"
            @change="changeExam(false, $event)"
            :icon-button="true"
            item-text="listText"
            item-value="exSrNo"
            class="toolbar-select oct-exam-select sideBySideToolbarSelect"/>
        </v-col>
        <v-col 
          v-if="sideBySideRightTimestamp"
          cols="12"
          lg="2"
          class="d-flex align-center mr-auto"
          order="2"
          order-lg="1">
          <span class="current-image-eye" :class="colorClass">{{sideBySideRightTimestamp}}</span>
        </v-col>
        <v-col cols="12"
          lg="2"
          class="d-flex align-center ml-auto"
          order="2">
          <image-button
            btnClass="toggleAnnotation ml-auto"
            title="Annotation Bar"
            :image="coloredAssetUrls.annotate"
            :small="ieButton"
            @click="toggleSideBySideAnnotation"/>
          <span class="current-image-eye" :class="colorClass">{{sideBySideRightEye}}</span>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import selectWithButton from "../controls/SelectWithButton";
import imageButton from "../controls/ImageButton";
import indexCounter from "../imageBrowser/IndexCounter";
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  name: "sideBySideBrowserToolbar",
  components: { selectWithButton, imageButton, indexCounter },
  computed: {
    ...mapGetters([
      "exams",
      "sideBySideLeftImages",
      "sideBySideLeftIndex",
      "sideBySideLeftExSrNo",
      "sideBySideRightImages",
      "sideBySideRightIndex",
      "sideBySideRightExSrNo",
      "sideBySideLeftEye",
      "sideBySideRightEye",
      "sideBySideLeftTimestamp",
      "sideBySideRightTimestamp",
      "isIE"
    ]),
    ieButton() {
      if (this.isIE)
        return true;
      return false;
    }
  },
  methods: {
    ...mapActions(["sideBySideSelectExam", "sideBySideSelectImage"]),
    ...mapMutations(["toggleSideBySideAnnotation"]),
    isDisabled(isLeft, increment) {
      let index = isLeft ? this.sideBySideLeftIndex : this.sideBySideRightIndex;
      let set = isLeft ? this.sideBySideLeftImages : this.sideBySideRightImages;
      let bound = increment ? set.length - 1 : 0;
      return index == bound;
    },
    changeImage(isLeft, increment) {
      if (this.isDisabled(isLeft, increment)) return;
      let images = isLeft
        ? this.sideBySideLeftImages
        : this.sideBySideRightImages;
      let index = isLeft ? this.sideBySideLeftIndex : this.sideBySideRightIndex;
      if (increment) index++;
      else index--;
      let image = images[index];
      this.sideBySideSelectImage({ image, isLeft });
    },
    changeExam(isLeft, exSrNo) {
      this.sideBySideSelectExam({ exSrNo, isLeft });
    }
  }
};
</script>
